import React from 'react';
import { DocumentsStats, LeadStats, TileCardProps } from './utils';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { NEW_WINDOW_PROPS } from 'data/global';

import './TileContainer.styles.scss';

type TileContainerProps<T extends string> = {
  className?: string;
  title: string;
  infoData: Partial<Record<T, TileCardProps>>;
  countData: Record<T, number>;
  tileContainerActions?: React.ReactNode;
  handleOnClick?: () => void;
};

function TileContainer<T extends LeadStats | DocumentsStats>(
  props: TileContainerProps<T>,
) {
  const {
    title,
    infoData,
    countData,
    tileContainerActions,
    className,
    handleOnClick,
  } = props;

  const classes = classNames(className, 'leads-container', {
    clickable: handleOnClick,
  });

  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={classes} onClick={handleOnClick}>
      <header className="leads-container__header">
        <p>{title}</p>
      </header>
      <main className="leads-container__content">
        {(Object.keys(infoData) as T[]).map((key) => {
          const count = countData[key] || 0;
          const { label, to, openInNewTab } = infoData[key];

          return (
            <div
              key={key}
              className={classNames(
                'leads-container__card',
                { clickable: to },
                key,
              )}
              {...(to && {
                onClick: (e) => {
                  e.stopPropagation();
                  openInNewTab
                    ? window.open(to, NEW_WINDOW_PROPS.target)
                    : navigate(to);
                },
              })}
            >
              <p>{count}</p>
              <div>{t(label, { count })}</div>
            </div>
          );
        })}
      </main>
      {tileContainerActions && (
        <div
          className="leads-container__actions"
          onClick={(e) => e.stopPropagation()}
        >
          {tileContainerActions}
        </div>
      )}
    </div>
  );
}
export default TileContainer;
